// One person panel for the whole dashboard: clicking a PersonAvatar opens it (PersonDialog, mounted
// once in pages/index/index.vue) with that address's contact card.
export const usePersonDialog = () => {
  const email = useState<string | null>('person-dialog-email', () => null);
  return { email, open: (address: string) => { email.value = address.trim().toLowerCase(); }, close: () => { email.value = null; } };
};
